import { SxProps, Theme } from '@mui/material';
import {
  DROPDOWN_OPTION_FONT_SIZE_SMALL,
  DROPDOWN_OPTION_PADDING_X,
} from '@onevision-resources/design-theme';
import type { ParticipantPillKind } from './participant-pill';

export const participantPillIconSx = (kind: ParticipantPillKind): SxProps<Theme> => ({
  color: (theme) => {
    const { sys } = theme.palette.custom.OV;
    if (kind === 'agent') return sys.secondary;
    if (kind === 'rsm') return sys.primary;
    if (kind === 'client') return theme.palette.warning.main;
    return sys.onSurfaceVariant;
  },
});

export const participantMenuHelpTextSx: SxProps<Theme> = {
  display: 'block',
  px: DROPDOWN_OPTION_PADDING_X,
  pt: 0.5,
  maxWidth: '14.75rem',
  fontSize: DROPDOWN_OPTION_FONT_SIZE_SMALL,
  lineHeight: 1.45,
  color: (theme) => theme.palette.custom.OV.sys.onSurfaceVariant,
};
